/* eslint-disable */
import 'select2';
import userService from './userService';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

export default {
  init() {
    // JavaScript to be fired on all pages
/*
    $('body').on('scroll', function() {
      // Check if the page is scrolled more than a certain amount (e.g., 50 pixels)
      var $navbar = $('.main-navigation'); // Reference to your navbar
        // console.log($(this).scrollTop());
      if ($(this).scrollTop() > 1) {
        $navbar.addClass('navbar--scrolled');
      } else {
        $navbar.removeClass('navbar--scrolled');
      }
    });
*/
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    // User Service
    userService.init();
    //********Navbar*****************



    //********Navbar Dropdown*****************
    if (window.matchMedia("(max-width: 769px)").matches) {
      $('.shop-link').click(function (event) {
        event.preventDefault(); // Prevent the default action
        // Do initial behavior from the shop link -> go to shop page
        window.location.href = this.href;
      });
    }
    if (window.matchMedia("(min-width: 769px)").matches) {
      $('.navbar .dropdown').hover(function () {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

      }, function () {
        $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

      });

      $('.navbar .dropdown > a').click(function () {
        location.href = this.href;
      });
    } else {
      $(this).find('.dropdown-menu')
    }

//*****************GSAP SCROLLTRIGGER***********
//     // Initialize GSAP and ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".main-navigation", {
      scrollTrigger: {
        trigger: "body",
        start: "top top",
        end: "bottom bottom",
        onUpdate: (self) => {
          if (self.direction === 1 && self.scroll() > 50) { // Scrolling down and past 50px
            $('.main-navigation').addClass('navbar--scrolled');
            $('.show-product-filter-container.sticky').css('background-color', 'var(--secondary)');
            $('.sidebar').css('background-color', '');
            $('.sidebar input[type="search"]').css('background-color', 'white');
          } else if (self.direction === -1 || self.scroll() <= 50) { // Scrolling up or less than 50px
            $('.main-navigation').removeClass('navbar--scrolled');
            $('.show-product-filter-container').css('background-color', 'white');
            $('.sidebar').css('background-color', 'white');
            $('.sidebar input[type="search"]').css('background-color', '');
          }
        }
      }
    });

//Hero
    gsap.from(".hero-modern-content", {
      duration: 0.4, // Duration of the animation in seconds
      backgroundColor: "#64b9af", // Target background color
      opacity: 0.6, // Target opacity
      // color: "white", // Target text color
    })

    gsap.from(".hero-slider-modern .col-lg-5", {
      duration: 1, // Duration of the animation in seconds
      x: 100,
      // color: "white", // Target text color
    });

    gsap.from(".hero-slider-modern .col-lg-7 picture", {
      duration: 1, // Duration of the animation in seconds
      y: 100,
      // color: "white", // Target text color
    });

//Text Media
    const tl = gsap.timeline();
    const textMediaImgs = gsap.utils.toArray(".col-2-text-media picture");
    const textMediaBGs = gsap.utils.toArray(".col-2-text-media.text_left_media_right .text-media-bg");
    const textMediaBGsOnLeft = gsap.utils.toArray(".col-2-text-media.text_right_media_left .text-media-bg");

    textMediaImgs.forEach((media) => {
      tl.to(media, {
        y: 40,
        duration: 0.8,
        scrollTrigger: {
          trigger: media,
          start: "top 80%",
          end: "top 20%",
          scrub: true,
        }
      });
    });

    textMediaBGs.forEach((background) => {
      tl.from(background, {
        x: 150,
        backgroundColor: "#64b9af",
        duration: 0.8,
        scrollTrigger: {
          trigger: background,
          start: "top 80%",
          end: "top 20%",
          scrub: true,
        },
      });
    });

    textMediaBGsOnLeft.forEach((background) => {
      tl.from(background, {
        x: -150,
        backgroundColor: "#64b9af",
        duration: 0.8,
        scrollTrigger: {
          trigger: background,
          start: "top 80%",
          end: "top 20%",
          scrub: true,
        },
      });
    });
//Icon Container
    const iconContainer = ".icon-container"; // Use the selector directly
    tl.from(iconContainer, {
      opacity: 0,
      scrollTrigger: {
        trigger: iconContainer,
        start: "top 80%",
        end: "top 20%",
        scrub: true,
      },
      stagger: 0.2 // Stagger the start of each icon's animation by 0.2 seconds
    });


// Product Container Animation
    const productContainer = ".col-4-products .product-container img"; // Use the product container selector
    tl.from(productContainer, {
      opacity: 0,
      y: 50,
      scrollTrigger: {
        trigger: productContainer,
        start: "top 80%",
        end: "top 20%",
        scrub: true,
      },
      stagger: 0.2 // Stagger the start of each product's animation by 0.2 seconds
    });

    const twoColumSections = gsap.utils.toArray(".col-2-content, .testimonials");

    twoColumSections.forEach((twoColumSection) => {
      tl.from(twoColumSection, {
        y: -20,
        opacity: 0.8,
        duration: 0.8,
        scrollTrigger: {
          trigger: twoColumSection,
          start: "top 60%",
          end: "top 20%",
          scrub: true,
        }
      });
    });

    // ScrollTrigger for Newsletter Section
    const newsletterSection = document.querySelector('.section.newsletter');

    if(newsletterSection) {
      ScrollTrigger.create({
        trigger: newsletterSection,
        start: "top 70%",
        end: "top 20%",
        onEnter: () => newsletterSection.classList.add('newsletter-dark'),
        onLeaveBack: () => newsletterSection.classList.remove('newsletter-dark')
      });
    }

    //********ADVISER SEARCH*****************
    $(document).ready(function () {
      var advisers = $('#advisers-wrapper').html();

      localStorage.removeItem('inSearch');
      localStorage.removeItem('advisers');

      localStorage.setItem('advisers', advisers);

      $("#searchAdviser").on("input", function () {

        var search = $("#searchAdviser").val();
        var advisers = $('#advisers-wrapper');
        var inSearch = localStorage.getItem('inSearch') || 'no';
        if (search.length === 0) {
          if (inSearch === 'yes') {
            advisers.html(localStorage.getItem('advisers'));
          }
        }
      });
    });

    $(document).on('click', '#searchAdviserFormSubmit', function (event) {
      event.preventDefault();
      var advisers = $('#advisers-wrapper');
      const ajax_url = window.site_util.ajax_url || false;
      var search = $('#searchAdviser').val();
      var searchType = $("#filter option:selected").val();
      var preLoader = $('.lds-ring');

      if (search.length >= 4) {
        var data = {
          search: search,
          type: searchType,
          action: 'adviser'
        };

        $.ajax({
          url: ajax_url,
          type: 'get',
          data: data,
          dataType: 'json',
          beforeSend: function () {
            advisers.empty();
            preLoader.show();
          },
          success: function (response) {
            advisers.empty();
            preLoader.hide();
            if (!response || response.length === 0) {
              advisers.append('<div><h2 style="color:#64b9af;">Leider keine Beraterin gefunden, bitte kontaktiere uns direkt:</h2><h3>NKV Colosé</h3><p>Marktplatz 21<br>4193 Reichenthal<br>Telefon: +43 (0)7214 / 50 288 <br>E-Mail: info@colose-nkv.com</p></div>');
            } else {
              advisers.html(response);
              localStorage.setItem('inSearch', 'yes');
            }
          },
        });
      }
    });

    $('.adviser-search #filter').on('change', function () {
      var search = $('#searchAdviser');
      var selectValue = $(this).val();
      if (selectValue == 'plz') {
        search.attr('placeholder', 'Postleitzahl')
      } else if (selectValue == 'name ') {
        search.attr('placeholder', 'Name')
      } else if (selectValue == 'ort') {
        search.attr('placeholder', 'Straße Nr, PLZ, Ort')
      }
    });

    $('#searchAdviser').keyup(function () {
      var advisers = $('#advisers-wrapper');
      const ajax_url = window.site_util.ajax_url || false;
      var search = $('#searchAdviser').val();
      var searchType = $("#filter option:selected").val();
      var preLoader = $('.lds-ring');

      if (search.length >= 4 && searchType !== 'ort') {
        var data = {
          search: search,
          type: searchType,
          action: 'adviser'
        };

        $.ajax({
          url: ajax_url,
          type: 'get',
          data: data,
          dataType: 'json',
          beforeSend: function () {
            advisers.empty();
            preLoader.show();
          },
          success: function (response) {
            console.log(response);
            // console.log(response)
            if (!response || response.length === 0) {
              advisers.empty();
              preLoader.hide();
              advisers.append('<div><h2 style="color:#64b9af;">Leider keine Beraterin gefunden, bitte kontaktiere uns direkt:</h2><h3>NKV Colosé</h3><p>Marktplatz 21<br>4193 Reichenthal<br>Telefon: +43 (0)7214 / 50 288 <br>E-Mail: info@colose-nkv.com</p></div>');

            } else {
              advisers.empty();
              preLoader.hide();
              advisers.html(response);
              localStorage.setItem('inSearch', 'yes');
            }

          },
        });
      } else {
        advisers.html(localStorage.getItem('advisers'));
      }
    });

    // *********************ADVISER SELECT**********************************

    function formatState(state) {
      if (!state.id) {
        return state.text;
      }

      if (state.thumbnail_url.length) {
        var $state = $(
          '<span><img class="adviser-select-image ml-0 ml-md-1 mr-1 mr-md-2" width="30" height="30" src="' + state.thumbnail_url + '" /> ' + state.text + '</span>'
        );
        return $state;
      } else {
        var $state = $(
          '<span><img style="padding: 5px;" class="adviser-select-image ml-0 ml-md-1 mr-1 mr-md-2" width="30" height="30" src="' + window.site_util.account_icon + '" /> ' + state.text + '</span>'
        );
        return $state;
      }
    }

    function getAdviserData() {
      var adviserSelect = $('#customer_adviser');
      if ($('#customer_adviser').val()) {
        var selected = $('#customer_adviser').val();
      } else {
        var selected = 0;
      }
      $.ajax({
        url: window.site_util.ajax_url,
        type: 'get',
        data: {
          action: 'get_adviser_select_data',
        },
        dataType: 'json',
        success: function (response) {
          var data = response;
          // console.log(data);
          adviserSelect.empty();
          adviserSelect.select2({
            data: data,
            templateResult: formatState
          });

          adviserSelect.val(selected).trigger('change');

        }
      });

    }

    getAdviserData();
    // *******************SELECT ADVISER SEARCH***************************
    $('#searchSelectableAdviser').on('click', function (event) {
      var adviserSelect = $('#customer_adviser');
      event.preventDefault();
      var searchVal = $('#selectAdviserSearch').val();
      const ajax_url = window.site_util.ajax_url || false;

      var data = {
        search: searchVal,
        type: 'adviser_select',
        action: 'adviser'
      };
      $.ajax({
        url: ajax_url,
        type: 'get',
        data: data,
        dataType: 'json',
        success: function (response) {
          console.log(response)
          adviserSelect.empty();
          adviserSelect.select2({
            data: response,
            templateResult: formatState
          });
          adviserSelect.val('0').trigger('change');
          adviserSelect.select2('open');
          $('<span class="d-flex justify-content-center p-1 bg-white" > <button id="show_all_advisers" class="btn btn-light" >Alle Beraterinnen anzeigen</button></span>').insertBefore('.select2-dropdown');
        },
      });
    });

    $(document).on('click', '#show_all_advisers', function (event) {
      event.preventDefault();
      var adviserSelect = $('#customer_adviser');
      adviserSelect.select2('close');
      adviserSelect.empty()
      getAdviserData();
      adviserSelect.select2('open');
      // adviserSelect.val('0').trigger('change');

    });

  },
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./scripts/routes/common.js